// The Earth stood up straight (?whatif=notilt): episode 7 of the Voidmode
// Studios channel, "What if Earth had no tilt?", and the scene its /v/7 link
// opens. The page draws the Earth with its spin axis on the ecliptic pole
// (obliquity 0) in place of the J2000 pole 23.44 degrees from it, so the
// Sun stays over the equator all year and the line between day and night
// runs through both poles every day.
//
// The video renderer drives it further (window.__tilt, set every frame from
// a shot's keys by src/video/shotcam.js):
//
// obliquity  the axis' angle from the ecliptic pole in degrees, so 23.44 is
//            today's Earth and a key from 23.44 to 0 stands it up.
// lean       the ecliptic longitude the axis leans toward, degrees: 90 is
//            the real axis (src/orbits/earthframe.js). Turning it 360
//            degrees back with the clock held is a year as the Sun sees it
//            (the axis keeps its direction while the Sun goes round), without
//            the Earth moving along its orbit: at a year in a few seconds the
//            Earth crosses tens of thousands of kilometres a frame, and the
//            renderer poses the camera against the bodies of the frame before.
// noon       { lon, hour } holds the spin so that longitude lon (degrees
//            east) reads local solar time hour: the subsolar meridian is
//            lon - 15 (hour - 12). Keying hour through 24 is one day, again
//            with the clock held; null spins with the clock.
// axis       true shows the spin axis (Teachers mode's rod, main.js
//            setLessonEarthAxis).
//
// Without the parameter none of this runs.

import { EARTH_OBLIQUITY } from './orbits/earthframe.js';

const DEG = Math.PI / 180;

export function tiltRequested(search) {
  return new URLSearchParams(search || '').get('whatif') === 'notilt';
}

export const tiltState = {
  obliquity: 0,
  lean: 90,
  noon: null,
  axis: false,
};

// Today's obliquity in degrees, for keys that start from the real Earth.
export const REAL_OBLIQUITY_DEG = EARTH_OBLIQUITY / DEG;

// The mesh spin (rotation.y inside the tilt group) that puts the subsolar
// meridian where noon asks. sunLocal is the Sun's direction in the tilt
// group's axes. A mesh turned by a carries its longitude lon (local
// (cos lon, 0, -sin lon), as src/video/shotcam.js groundPose reads places)
// to the tilt group's longitude lon + a, so the Sun, at the tilt group's
// longitude atan2(-z, x), stands over the mesh's lon when a = that - lon.
export function heldSpinAngle(sunLocal, noon) {
  const sunLon = Math.atan2(-sunLocal.z, sunLocal.x);
  const subsolar = (noon.lon - 15 * (noon.hour - 12)) * DEG;
  const a = sunLon - subsolar;
  return ((a % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
}

export function installTiltHook() {
  window.__tilt = {
    state: tiltState,
    set(s) {
      if (!s) return;
      if (Number.isFinite(s.obliquity)) tiltState.obliquity = s.obliquity;
      if (Number.isFinite(s.lean)) tiltState.lean = s.lean;
      if (s.noon !== undefined) tiltState.noon = s.noon && Number.isFinite(s.noon.lon) ? { lon: s.noon.lon, hour: Number.isFinite(s.noon.hour) ? s.noon.hour : 12 } : null;
      if (s.axis !== undefined) tiltState.axis = Boolean(s.axis);
    },
  };
}
